<template>
  <el-dialog
    :visible.sync="showEdit"
    width="800px"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="简历"
    @closed="handleClose"
    :close-on-click-modal="true"
    class="biographical-notes"
  >
    <!-- //简历生成器、面试助手(大数据量(30000000)、高并发(5000/s))、博客、云记事、通讯\社交(大数据量500000000、高并发(100000/s))、短视频直播(大数据量50000000、高并发(1000000/s))、招聘(大数据量(100000000)、高并发(3000/s))、资讯、工具箱(整合前面几个)-->
    <!-- 1、js+css+html+vue+Go -->
    <!-- 2、js+css+html|uniApp+vue+Spting+SpringMvc+MyBatis｜v2:ssh -->
    <!-- 3、js+css+html|weex+vue+SpringBoot｜v2:SSM -->
    <!-- 4、js+css+html|weex/uniApp+React+SpringBoot｜v2:SSM -->
    <!-- 5、js+css+html|uniApp/Mui+vue+SpringCloud -->
    <!-- 6、js+css+html|weex+vue+SpringCloud｜v2:Go -->
    <!-- 7、js+css+html|UniApp+React+SptingBoot｜v2:SSM -->
    <!-- 8、js+css+html|UniApp+Angular.js+SptingBoot -->
    <!-- 8、js+css+html|weex+vue+SpringCloud -->
    <div class="biographical-notes-container">
      <div class="notes-profile-information">
        <div class="infor-profile-li1">
          <div class="profile-avatar">
            <img :src="preViewUrl+biodata.avatar"/>
          </div>
          <label>{{biodata&&biodata.nickname?biodata.nickname:'匿名'}}</label>
        </div>
        <div class="infor-profile-li2">
          <div class="profile-li-title">
            <label>个人基本信息</label>
          </div>
          <div class="profile-li-line"></div>
          <div class="profile-li">
            <label>性别:</label>
            <label>{{biodata.sex==0?'女':'男'}}</label>
          </div>
          <div class="profile-li">
            <label>年龄:</label>
            <label>{{biodata.age}}岁</label>
          </div>
          <div class="profile-li">
            <label>现居城市:</label>
            <label>{{biodata.residence}}</label>
          </div>
          <div class="profile-li">
            <label>期望薪资:</label>
            <label>{{biodata.salary}}</label>
          </div>
          <div class="profile-li">
            <label>手机号:</label>
            <label>{{biodata.mobile}}</label>
          </div>
          <div class="profile-li">
            <label>邮箱:</label>
            <label>{{biodata.email}}</label>
          </div>
        </div>
        <div class="infor-profile-li2">
          <div class="profile-li-title">
            <label>爱学界个人空间展示</label>
          </div>
          <div class="profile-li-line"></div>
          <div class="profile-li-container">
            <div @click="$message({message:'请到移动端查看！',})" :class="biodata.showclub_center==1?'li-container-item active':'li-container-item nopoint'">秀吧</div>
            <div @click="$message({message:'请到移动端查看！',})"  :class="biodata.party_center==1?'li-container-item active':'li-container-item nopoint'">约吧</div>
            <div @click="$message({message:'请到移动端查看！',})"  :class="biodata.lecturehall_center==1?'li-container-item active':'li-container-item nopoint'">看吧</div>
            <div @click="$message({message:'请到移动端查看！',})"  :class="biodata.appointment_center==1?'li-container-item active':'li-container-item nopoint'">聚吧</div>
            <div @click="$message({message:'请到移动端查看！',})"  :class="biodata.readclub_center==1?'li-container-item active':'li-container-item nopoint'">读吧</div>
            <div @click="$message({message:'请到移动端查看！',})"  :class="biodata.competition_center==1?'li-container-item active':'li-container-item nopoint'">赛吧</div>
            <div @click="$message({message:'请到移动端查看！',})" :class="biodata.info_center==1?'li-container-item active':'li-container-item nopoint'">资讯</div>
          </div>
        </div>
      </div>
      <div class="notes-occupation-information">
        <div class="occupation-infor-profile">
          <div class="infor-profile-li">
            <div class="profile-li-content"> 投递职位：{{checkedRow.checkedRow?checkedRow.checkedRow.name:'直通车'}}</div>
            <div class="profile-li-logo"> 
              <img src="https://aixuejie-test.oss-cn-hangzhou.aliyuncs.com/axj_web_file/axj_main/icon/logo.png"/>
            </div>
            <!-- // -->
          </div>
          <div class="infor-profile-li">投递时间：{{createTime|parseTime2}}</div>
        </div>
        <div class="occupation-infor-container">
          <div class="occupation-infor-li">
            <div class="infor-li-title">个人简介</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container">
              <div class="infor-li-content">
                {{biodata.introduction}}
              </div>
            </div>
          </div>
          <div class="occupation-infor-li">
            <div class="infor-li-title">教育经历</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container list">
              <div class="infor-li-content" :key="x.id" v-for='x in baseData' v-if="x.type==1">
                <label
                  >· {{x.start_time|parseTime}} - {{x.end_time|parseTime}} {{x.name}} | {{x.qualification}} | {{x.major}}</label
                >
              </div>
            </div>
          </div>
          <div class="occupation-infor-li">
            <div class="infor-li-title">科研成果</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container list">
              <div class="infor-li-content"  :key="x.id" v-for='x in baseData' v-if="x.type==2">
                <label>· {{x.name}}</label>
                <div class="infor-content-remark">
                  {{x.summary}}
                </div>
              </div>
            </div>
          </div>
          <div class="occupation-infor-li">
            <div class="infor-li-title">论文专著</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container list">
              <div class="infor-li-content" :key="x.id" v-for='x in baseData' v-if='x.type==3'>
                <label>· {{x.name}}</label>
              </div>
              
            </div>
          </div>
          <div class="occupation-infor-li">
            <div class="infor-li-title">发明专利</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container list">
              <div class="infor-li-content" :key="x.id" v-for='x in baseData' v-if="x.type==4">
                <label>· {{x.name}}</label>
              </div>
            </div>
          </div>
          <div class="occupation-infor-li de-bottom">
            <div class="infor-li-title">专业特长</div>
            <div class="infor-li-line"></div>
            <div class="infor-li-container list">
              <div class="infor-li-content" :key="x.id" v-for='x in baseData' v-if="x.type==5">
                <label>· {{x.summary}}</label>
              </div>
            </div>
          </div>
          <div class="occupation-infor-li tool">
            <div class="tool-left">
              <button @click="handlePrint">打印</button>
              <button @click="editServiceWorkOfferDelivererRelation">{{isMark!=0?'已标记':'标记'}}</button>
            </div>
            <div class="tool-rigth">
              <button class="last" @click="last">
                <span></span>
              </button>
              <button @click="handleClose" class="close">
                <label>关闭</label>
              </button>
              <button class="next" @click="next">
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import commonModels from '@/common/models/common-models'
import {GetUserCurriculumVitaes,GetUserCurriculumVitaeBaseinfos,EditServiceWorkOfferDelivererRelation}  from "@/api/axj-service/axj-service-work"
export default {
  name: "biographical-notes",
  components: {},
  created() {},
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters: {
    parseTime(time) {
      return commonModels.formatTime(time, 'Y.M')
    },
    parseTime2(time){
      return commonModels.formatTime(time, 'Y/M/D')
    }
  },
  data(){
    return{
      biodata:{},
      baseData:[],
      work:{

      },
      showEdit:false,
      isMark:0
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userId:{
      type:Number,
      default:0
    },
    checkedRow:{
      type:Object,
      default:undefined
    },
    createTime:{
      type:Number,
      default:0
    },
    index:{
      type:Number,
      default:0
    },
    mark_id:{
      type:Number,
      default:0
    },
    offerdeliverersId:{
      type:Number,
      default:0
    }
  },
 watch:{
   userId(){
     this.initData()
   },
   show(v){
     this.showEdit=v
   },
   mark_id(v){
     this.isMark=v
   }
 },
  methods: {
    editServiceWorkOfferDelivererRelation(){
      let id= this.$store.getters.getUser.info.ServiceWorkUser.id
      EditServiceWorkOfferDelivererRelation({
        id:this.offerdeliverersId,
        where:JSON.stringify({
          mark_id:this.isMark!=0?0:id
        })
      }).then(res=>{
        this.isMark=this.isMark!=0?0:id
        this.$emit("marked")
        this.initData()
      },error=>{
      })
    },
    next(){
      this.$emit('next',this.index)
    },
    last(){
      this.$emit('last',this.index)
    },
    initData(){
      GetUserCurriculumVitaes(this.userId).then(res=>{
        this.biodata=res.data
      },error=>{
        console.log(error)
      })
      GetUserCurriculumVitaeBaseinfos(this.userId).then(res=>{
        console.log(res.data)
        this.baseData=res.data.lists
      })
    },
    handleClose(){
      console.log('你好啊')
      this.showEdit=false
      this.$emit("update:show",false)
    },
    handleOpen(){
      //this.initData()
    },
    handlePrint() {
      console.log('打印..')
      // document.querySelector(".biographical-notes-container").outerHTML;
      // document.body.style.paddingLeft="auto"
      // document.body.style.paddingRight="auto"
      // let realHtml=document.body.innerHTML
      // document.body.innerHTML = document.querySelector(
      //   ".biographical-notes-container"
      // ).outerHTML;
      // window.print();
      // window.location.reload()
      //let toolHtml= document.body.querySelector('.occupation-infor-li.tool')
      let html=document.body.querySelector('.biographical-notes-container').outerHTML
      let newWin= window.open("")
      newWin.document.write("<html><head></head><body>"+html+"</body><style>.biographical-notes-container{display:flex;width:800px}.biographical-notes-container .notes-occupation-information{flex:1}.biographical-notes-container .notes-occupation-information .occupation-infor-profile{background-color:#f2f5f8;height:84px;display:flex;flex-direction:column}.biographical-notes-container .notes-occupation-information .occupation-infor-profile .infor-profile-li{width:449px;margin-left:auto;font-family:Source Han Sans CN;font-style:normal;font-weight:350;font-size:16px;line-height:23px;color:#75878a;display:flex;justify-content:space-between}.biographical-notes-container .notes-occupation-information .occupation-infor-profile .infor-profile-li .profile-li-logo{width:101px;height:23px;margin-right:27px}.biographical-notes-container .notes-occupation-information .occupation-infor-profile .infor-profile-li .profile-li-logo img{width:101px;height:23px}.biographical-notes-container .notes-occupation-information .occupation-infor-profile .infor-profile-li:first-child{margin-top:24px}.biographical-notes-container .notes-occupation-information .occupation-infor-container{background-color:#fff}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool{margin-top:60px;height:55px;display:flex;align-items:center;position:absolute;bottom:20px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-left button:first-child{outline:0;border:0;background:#d1d9e0;border-radius:20px;width:88px;height:31px;margin-right:8px;color:#41555d;font-weight:500}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-left button{cursor:pointer}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-left button:last-child{background:#75878a;border-radius:20px;width:88px;height:31px;outline:0;border:0;color:#fff;font-weight:500}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth{margin-left:auto;display:flex;align-items:center}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button:first-child{margin-right:12px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button:first-child span{margin-left:3px;-webkit-transform:rotate(315deg);transform:rotate(315deg)}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button.close{border-radius:10%;width:40px;height:28px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button.close label{color:#fff;font-size:12px;cursor:pointer}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button:last-child{margin-left:12px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button:last-child span{-webkit-transform:rotate(135deg);transform:rotate(135deg)}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button{cursor:pointer;border-radius:100%;width:31px;height:31px;outline:0;border:0;background:#75878a}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.tool .tool-rigth button span{display:block;width:10.05px;height:10.05px;border-top:3px solid #fff;border-radius:2px;border-left:3px solid #fff}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li.de-bottom{margin-bottom:110px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li{width:422px;margin-left:33px;margin-top:25px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li .infor-li-title{font-family:Source Han Sans CN;font-style:normal;font-weight:500;font-size:20px;line-height:29px;color:#41555d}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li .infor-li-line{height:1px;background-color:#d1d9e0}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li .infor-li-container.list .infor-li-content .infor-content-remark{font-family:Source Han Sans CN;font-style:normal;font-weight:350;font-size:12px;line-height:17px;color:#75878a;margin-left:10px;margin-top:5px}.biographical-notes-container .notes-occupation-information .occupation-infor-container .occupation-infor-li .infor-li-container .infor-li-content{margin-top:16px;margin-left:16px;font-family:Source Han Sans CN;font-style:normal;font-weight:350;font-size:14px;line-height:20px;color:#41555d}"+
      ".biographical-notes-container .notes-profile-information{background-color:#75878a;width:318px}.biographical-notes-container .notes-profile-information .infor-profile-li1{height:225px;display:flex;align-items:center;justify-content:center;flex-direction:column}.biographical-notes-container .notes-profile-information .infor-profile-li1 label{font-family:Source Han Sans CN;font-style:normal;font-weight:500;font-size:28px;line-height:41px;color:#fff;margin-top:13px}.biographical-notes-container .notes-profile-information .infor-profile-li1 .profile-avatar{width:99px;height:99px;border-radius:100%;background-color:#c4c4c4;border:5px solid #41555d}.biographical-notes-container .notes-profile-information .infor-profile-li1 .profile-avatar img{width:99px;height:99px;border-radius:100%}.biographical-notes-container .notes-profile-information .infor-profile-li2{width:277px;margin-left:auto;display:flex;flex-direction:column}.biographical-notes-container .notes-profile-information .infor-profile-li2 .profile-li-title{font-family:Source Han Sans CN;font-style:normal;font-weight:500;font-size:20px;line-height:29px;color:#fff}.biographical-notes-container .notes-profile-information .infor-profile-li2 .profile-li-line{height:1px;background-color:#fff}.biographical-notes-container .notes-profile-information .infor-profile-li2 .profile-li{margin-top:22px}.biographical-notes-container .notes-profile-information .infor-profile-li2 .profile-li label{font-family:Source Han Sans CN;font-style:normal;font-weight:500;font-size:16px;line-height:23px;color:#fff}.biographical-notes-container .notes-profile-information .infor-profile-li2:last-child{margin-top:34px}.biographical-notes-container .notes-profile-information .infor-profile-li2:last-child .profile-li-container{display:flex;flex-flow:wrap;margin-top:3px;margin-bottom:100px}.biographical-notes-container .notes-profile-information .infor-profile-li2:last-child .profile-li-container .li-container-item{cursor:pointer;color:#fff;display:flex;align-items:center;justify-content:center;background-color:#d1d9e0;border-radius:5px;width:65px;height:32px;margin-right:11px;margin-top:11px}.biographical-notes-container .notes-profile-information .infor-profile-li2:last-child .profile-li-container .li-container-item.active{background:#41555d}.biographical-notes-container .notes-profile-information .infor-profile-li2:last-child .profile-li-container .li-container-item.nopoint{cursor:default}</style></html>")
      console.log(newWin.document.querySelector('.occupation-infor-li.tool'))
      newWin.document.querySelector('.occupation-infor-li.tool').parentNode.removeChild(newWin.document.querySelector('.occupation-infor-li.tool'))
      newWin.print()
      newWin.close()
      // newWin.body.innerHTML=window.document.querySelector(
      //   ".biographical-notes-container"
      // ).outerHTML;
      //document.body.innerHTML=realHtml

      // document.querySelector('.biographical-notes-container').querySelector('.last').addEventListener('click', this.last);
      // document.querySelector('.biographical-notes-container').querySelector('.next').addEventListener('click', this.next);
      // document.querySelector('.biographical-notes').addEventListener('click', function(){
      //   console.log('hello world')
      //   document.querySelector('.curriculum-vitae').removeChild(document.querySelector('.biographical-notes'))
      // });
      // document.querySelector('.biographical-notes-container').querySelector('.close').addEventListener('click', function(){
      //   console.log(document.querySelector('.curriculum-vitae'))
      //   document.querySelector('.curriculum-vitae').parentNode.removeChild(document.querySelector('.curriculum-vitae'))
      // });
    },
  },
};
</script>
<style lang="scss" slot-scoped>
.biographical-notes {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    margin: 0;
  }
}
.biographical-notes-container {
  display: flex;
  width:800px;
  .notes-occupation-information {
  flex: 1;
  .occupation-infor-profile {
    background-color: #f2f5f8;
    height: 84px;
    display: flex;
    flex-direction: column;
    .infor-profile-li {
      width: 449px;
      margin-left: auto;
      font-family: Source Han Sans CN;
      font-style: normal;
      font-weight: 350;
      font-size: 16px;
      line-height: 23px;
      color: #75878a;
      display: flex;
      justify-content: space-between;
      .profile-li-logo{
        width: 101px;
        height: 23px;
        margin-right: 27px;
        img{
          width: 101px;
          height: 23px;
        }
      }
    }
    .infor-profile-li:first-child {
      margin-top: 24px;
    }
  }
  .occupation-infor-container {
    background-color: #ffffff;
    .occupation-infor-li.tool {
      margin-top: 60px;
      height: 55px;
      display: flex;
      align-items: center;
      position:absolute;
      bottom: 20px;
      .tool-left {
        button:first-child {
          outline: none;
          border: none;
          background: #d1d9e0;
          border-radius: 20px;
          width: 88px;
          height: 31px;
          margin-right: 8px;
          color: #41555d;
          font-weight: 500;
        }
        button {
          cursor: pointer;
        }
        button:last-child {
          background: #75878a;
          border-radius: 20px;
          width: 88px;
          height: 31px;
          outline: none;
          border: none;
          color: #ffffff;
          font-weight: 500;
        }
      }
      .tool-rigth {
        margin-left: auto;
        display: flex;
        align-items: center;
        button:first-child {
          margin-right: 12px;
          span {
            margin-left: 3px;
            -webkit-transform: rotate(315deg);
            transform: rotate(315deg);
          }
        }
        button.close{
          label{
            color: #ffffff;
            font-size: 12px;
            cursor: pointer;
          }
          border-radius: 10%;
          width: 40px;
          height: 28px;
        }
        button:last-child {
          margin-left: 12px;
          span {
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
          }
        }
        button {
          cursor: pointer;
          border-radius: 100%;
          width: 31px;
          height: 31px;
          outline: none;
          border: none;
          background: #75878a;
          span {
            display: block;
            width: 10.05px;
            height: 10.05px;
            border-top: 3px solid #fff;
            border-radius: 2px;
            border-left: 3px solid #fff;
          }
        }
      }
    }
    .occupation-infor-li.de-bottom{
      margin-bottom: 110px;
    }
    .occupation-infor-li {
      width: 422px;
      margin-left: 33px;
      margin-top: 25px;
      .infor-li-title {
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 29px;
        /* identical to box height */
        color: #41555d;
      }
      .infor-li-line {
        height: 1px;
        background-color: #d1d9e0;
      }
      .infor-li-container.list {
        .infor-li-content {
          .infor-content-remark {
            font-family: Source Han Sans CN;
            font-style: normal;
            font-weight: 350;
            font-size: 12px;
            line-height: 17px;
            color: #75878a;
            margin-left: 10px;
            margin-top: 5px;
          }
        }
      }

      .infor-li-container {
        .infor-li-content {
          margin-top: 16px;
          margin-left: 16px;
          font-family: Source Han Sans CN;
          font-style: normal;
          font-weight: 350;
          font-size: 14px;
          line-height: 20px;
          color: #41555d;
        }
      }
    }
  }
}
.notes-profile-information {
  background-color: #75878a;
  width: 318px;
  .infor-profile-li1 {
    height: 225px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    label {
      font-family: Source Han Sans CN;
      font-style: normal;
      font-weight: 500;
      font-size: 28px;
      line-height: 41px;
      /* identical to box height */
      color: #ffffff;
      margin-top: 13px;
    }
    .profile-avatar {
      width: 99px;
      height: 99px;
      border-radius: 100%;
      background-color: #c4c4c4;
      border: 5px solid #41555d;
      img {
        width: 99px;
        height: 99px;
        border-radius: 100%;
      }
    }
  }
  .infor-profile-li2 {
    width: 277px;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    .profile-li-title {
      font-family: Source Han Sans CN;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 29px;
      /* identical to box height */
      color: #ffffff;
    }
    .profile-li-line {
      height: 1px;
      background-color: #ffffff;
    }
    .profile-li {
      margin-top: 22px;
      label {
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 23px;
        color: #ffffff;
      }
    }
  }
  .infor-profile-li2:last-child {
    margin-top: 34px;
    .profile-li-container {
      display: flex;
      flex-flow: wrap;
      margin-top: 3px;
      margin-bottom: 100px;
      .li-container-item {
        cursor: pointer;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        // background: #41555d;
        background-color: #d1d9e0;
        border-radius: 5px;
        width: 65px;
        height: 32px;
        margin-right: 11px;
        margin-top: 11px;
      }
      .li-container-item.active{
        background: #41555d;
      }
      .li-container-item.nopoint{
        cursor:default;
      }
    }
  }
}
}


</style>


// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/biographical-notes/index.vue